import React, {useState, useEffect} from "react"
import {connect} from "react-redux"
import {bindActionCreators} from "redux"
import {toggleDevStrings} from '../../redux/actions'
import {Row, Col} from 'react-bootstrap'
import {DevIcon, CloseIcon} from '../svg'
import StringsIcon from '../svg/menu/Strings'
import InfoItem from "./InfoItem"
import {checkPermission} from "../../helpers/checkPermission"
import _isEmpty from 'lodash/isEmpty'

const Dev = (props) => {
    const {info, auth, isDevStrings} = props
    const isAuthenticated = auth.isAuthenticated
    const [visible, setVisible] = useState(false)
    const [devMode, setDevMode] = useState(false)
    const [devStrings, setDevStrings] = useState(isDevStrings)

    useEffect(() => {
        if(isAuthenticated){
            setTimeout(() => {
                setVisible(true)
            }, 2500)
        }
    }, [isAuthenticated])

    useEffect(() => {
        setDevStrings(isDevStrings)
    }, [isDevStrings])

    if(!isAuthenticated || !auth.user.master){
        return null
    }

    const toggleDevMode = () => {
        setDevMode(!devMode)
    }

    const toggleDevStrings = () => {
        setDevStrings(!devStrings)
        props.actions.toggleDevStrings()
    }

    const stringPermission = checkPermission('admin-string.view', auth.user)

    return(
        <div className={`dev ${devMode ? 'active' : ''} ${visible ? 'dev-visible' : ''}`}>
            {
                devMode ? (
                    <div className="dev-inner d-flex flex-column justify-content-between">
                        <div className="close-icon" onClick={toggleDevMode}><CloseIcon/></div>
                        <div>
                            <div><InfoItem value={info.env} label="general.environment" as="span"/></div>
                            <div><InfoItem value={info.locale} label="general.locale" as="span"/></div>
                        </div>
                        <Row>
                            {
                                stringPermission &&
                                    <Col xs={12}>
                                        <button type="button" className={`btn btn-outline-primary ${devStrings ? "active" : ""}`} onClick={toggleDevStrings}><StringsIcon/></button>
                                    </Col>
                            }
                        </Row>
                    </div>
                ) : (
                    <div className="icon-inner" onClick={toggleDevMode}>
                        <DevIcon/>
                    </div>
                )
            }
        </div>
    )
}

function mapStateToProps(state) {
    return {
        info: state.info.data,
        auth: state.auth,
        isDevStrings: !_isEmpty(state.strings.original)
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            toggleDevStrings
        }, dispatch)
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Dev)